import { useEffect, useState } from 'react';
import { getInfoContentService } from '../../../services/customer/infoContentServices';

function useTermsAndConditions({ type }) {
  const [termsAndConditions, setTermsAndConditions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getInfoContentService({ type });
      if (res.status === 'success') {
        setTermsAndConditions(res?.data);
      }
    };
    fetchData();
  }, []);
  return termsAndConditions;
}

export default useTermsAndConditions;
